import { OnboardingReminder } from '@models/employee/onboarding-reminder.model';

export class OffboardingReminder extends OnboardingReminder {
    protected static _resource = 'companyManagement/companies/:company/offboardingReminders';
}
